import { atom } from 'jotai';

export const fullPageLoadingSpinnerAtoms = {
  showSpinner: atom<boolean>(false),
};
